<template>
  <header
    :class="classes"
    class="mdc-top-app-bar"
    @MDCTopAppBar:nav="onNavigation()"
  >
    <div class="mdc-top-app-bar__row" v-if="isPortada">
      <section
        v-if="$slots['navigation'] || title"
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
      >
        <slot name="navigation" />
        <div style="margin-left: 20px; margin-top: 30px">
          <div class="app-footer__logo-organization">
            <img
              src="@/assets/logo-white-no-label--new.png"
              alt="Logo Junta de Andalucía"
            />
          </div>
          <div class="app-footer__title-organization">
            <div class="app-footer__title-organization__junta">
              Junta de Andalucía
            </div>
            <div class="app-footer__title-organization__consejeria">
              Consejería de Vivienda, Juventud y Ordenación del Territorio
            </div>
            <div class="app-footer__title-organization__avra">
              AGENCIA DE VIVIENDA Y REHABILITACIÓN DE ANDALUCÍA
            </div>
          </div>
          <slot name="start" />
        </div>
      </section>
      <slot />
      <section
        v-if="$slots['actions']"
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
        role="toolbar"
      >
        <slot name="end" />
        <slot name="actions" />
      </section>
    </div>

    <div class="mdc-top-app-bar__row" v-if="!isPortada">
      <section
        v-if="$slots['navigation'] || title"
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start app-linkable"
      >
        <slot name="navigation" />
        <span
          v-if="title.length > 0"
          class="mdc-top-app-bar__title mda-hide-on-not-desktop"
          @click="onTitleClick()"
        >
          {{ title }}
        </span>

        <span
          v-if="titleMobile.length > 0"
          class="mdc-top-app-bar__title  mda-hide-on-desktop"
          @click="onTitleClick()"
        >
          {{ titleMobile }}
        </span>
        <slot name="start" />
      </section>
      <slot />
      <section
        v-if="$slots['actions']"
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
        role="toolbar"
      >
        <slot name="end" />
        <slot name="actions" />
      </section>
    </div>
  </header>
</template>

<script>
import { MDCTopAppBar } from "@material/top-app-bar";

import { baseComponentMixin, themeClassMixin } from "../base";

export default {
  mixins: [baseComponentMixin, themeClassMixin],
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    },
    prominent: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    titleMobile: {
      type: String,
      default: ""
    },
    scrollTarget: {
      type: Object,
      default: () => undefined,
      validator: val => val instanceof EventTarget
    }
  },
  data() {
    return {
      mdcTopAppBar: undefined,
      slotObserver: undefined
    };
  },
  computed: {
    isPortada() {
      return this.$route.path === "/";
    },
    classes() {
      return {
        "mdc-top-app-bar--short": this.short && !this.collapsed,
        "mdc-top-app-bar--short-collapsed": this.collapsed && this.short,
        "mdc-top-app-bar--prominent": this.prominent && !this.short,
        "mdc-top-app-bar--dense": this.dense && !this.short,
        "mdc-top-app-bar--fixed": this.fixed && !this.short
      };
    }
  },
  watch: {
    scrollTarget(el) {
      if (this.mdcTopAppBar && el) {
        this.mdcTopAppBar.setScrollTarget(el);
      }
    }
  },
  mounted() {
    this.updateSlots();
    this.slotObserver = new MutationObserver(() => this.updateSlots());
    this.slotObserver.observe(this.$el, {
      childList: true,
      subtree: true
    });

    this.mdcTopAppBar = MDCTopAppBar.attachTo(this.$el);
    if (this.scrollTarget && this.scrollTarget !== window)
      this.mdcTopAppBar.setScrollTarget(this.scrollTarget);
  },
  beforeDestroy() {
    this.slotObserver.disconnect();
    this.mdcTopAppBar.destroy();
  },
  methods: {
    updateSlots() {
      if (this.$slots.navigation) {
        this.$slots.navigation.forEach(n => {
          if (n.elm instanceof Element)
            n.elm.classList.add("mdc-top-app-bar__navigation-icon");
        });
      }
      if (this.$slots.actions) {
        this.$slots.actions.forEach(n => {
          if (n.elm instanceof Element) {
            n.elm.classList.add("mdc-top-app-bar__action-item");
          }
        });
      }
    },
    onNavigation() {
      this.$emit("nav");
    },
    onTitleClick() {
      this.$emit("titleClick");
    }
  }
};
</script>
